import { render, staticRenderFns } from "./Observacion.vue?vue&type=template&id=4ac19846&"
import script from "./Observacion.vue?vue&type=script&lang=js&"
export * from "./Observacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports